export const siteTypes = {
    portfolio: 'portfolio',
    placeholder: 'placeholder',
};

export const sites = {
    root: {
        id: 'root',
        type: siteTypes.placeholder,
        hostnames: ['esmenava.com', 'www.esmenava.com'],
        defaultLanguage: 'es',
        supportedLanguages: ['es', 'en'],
    },
    dev: {
        id: 'dev',
        type: siteTypes.portfolio,
        hostnames: ['dev.esmenava.com', 'localhost', '127.0.0.1'],
        defaultLanguage: 'es',
        supportedLanguages: ['es', 'en'],
        copyProfile: 'dev',
        projectsDataset: 'dev',
        ecommerceDataset: 'dev',
        seoProfile: 'dev',
    },
    data: {
        id: 'data',
        type: siteTypes.portfolio,
        hostnames: ['data.esmenava.com'],
        defaultLanguage: 'es',
        supportedLanguages: ['es', 'en'],
        copyProfile: 'data',
        projectsDataset: 'data',
        ecommerceDataset: 'data',
        seoProfile: 'data',
    },
    ops: {
        id: 'ops',
        type: siteTypes.portfolio,
        hostnames: ['ops.esmenava.com'],
        defaultLanguage: 'es',
        supportedLanguages: ['es', 'en'],
        copyProfile: 'ops',
        projectsDataset: 'ops',
        ecommerceDataset: 'ops',
        seoProfile: 'ops',
    },
};

export const defaultSiteId = 'dev';

export function getActiveSite(hostname = window.location.hostname) {
    const cleanHostname = hostname.split(':')[0].toLowerCase();

    const matchedSite = Object.values(sites).find((site) =>
        site.hostnames.includes(cleanHostname)
    );

    if (matchedSite) {
        return matchedSite;
    }

    const subdomain = cleanHostname.split('.')[0];

    return sites[subdomain] || sites[defaultSiteId];
}
